/* ==========================================================================
   Exin — Nyinkommet
   Hörnkort (lager 1) som expanderar till panel/lightbox (lager 2).
   Frekvens + dismiss via localStorage (samma mönster som subscription-popup).
   ========================================================================== */
(function () {
  'use strict';

  var SEEN_KEY = 'exin:nyinkommet:seen';
  var DISMISS_KEY = 'exin:nyinkommet:dismissed';
  var VIEWS_KEY = 'exin:nyinkommet:views';
  var PENDING_KEY = 'exin:nyinkommet:secondchance';

  function store() {
    if (window.FoxTheme && window.FoxTheme.utils && window.FoxTheme.utils.setStorage) {
      return window.FoxTheme.utils;
    }
    return {
      setStorage: function (k, v, days) {
        try {
          var o = { value: v };
          if (days != null) o.expiry = Date.now() + days * 86400000;
          window.localStorage.setItem(k, JSON.stringify(o));
        } catch (e) {}
      },
      getStorage: function (k) {
        try {
          var s = window.localStorage.getItem(k);
          if (!s) return null;
          var o = JSON.parse(s);
          if (o.expiry && Date.now() > o.expiry) {
            window.localStorage.removeItem(k);
            return null;
          }
          return o.value;
        } catch (e) {
          return null;
        }
      }
    };
  }

  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (customElements.get('exin-nyinkommet')) return;

  customElements.define(
    'exin-nyinkommet',
    class ExinNyinkommet extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.cfg = {
          trigger: this.dataset.trigger || 'both', // delay | scroll | both
          delayMs: parseInt(this.dataset.delayMs, 10) || 3000,
          scrollPx: parseInt(this.dataset.scrollPx, 10) || 600,
          rotateMs: parseInt(this.dataset.rotateMs, 10) || 4500,
          frequencyHours: parseFloat(this.dataset.frequencyHours) || 24,
          dismissDays: parseFloat(this.dataset.dismissDays) || 7
        };

        // Byggläge: strunta i frekvens/dismiss – visa vid varje sidladdning.
        this.alwaysOn = this.dataset.alwaysOn === 'true';

        this.cc = this.querySelector('.exin-nyin-cc');
        this.stage = this.querySelector('.exin-nyin-cc__stage');
        this.thumbs = this.querySelector('.exin-nyin-cc__thumbs');
        this.peek = this.querySelector('.exin-nyin-cc__peek');
        this.countEl = this.querySelector('.exin-nyin-cc__count');
        this.moreBtn = this.querySelector('.exin-nyin-cc__more');
        this.panel = this.querySelector('.exin-nyin-panel');
        this.panelBox = this.querySelector('.exin-nyin-panel__box');
        this.panelBackdrop = this.querySelector('.exin-nyin-panel__backdrop');
        this.panelGrid = this.querySelector('.exin-nyin-panel__grid');
        this.ccPrev = this.querySelector('.exin-nyin-cc__nav--prev');
        this.ccNext = this.querySelector('.exin-nyin-cc__nav--next');
        this.panelPrev = this.querySelector('.exin-nyin-panel__nav--prev');
        this.panelNext = this.querySelector('.exin-nyin-panel__nav--next');

        var tpl = this.querySelector('template.exin-nyin-source');
        this.cards = [];
        if (tpl) {
          var frag = tpl.content.cloneNode(true);
          this.cards = Array.prototype.slice.call(frag.querySelectorAll('[data-nyin-card]'));
        }
        if (!this.cards.length || !this.cc) return;

        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        var isMobile = vw > 0 && vw <= 749;

        // this.cards = ALLA tillgängliga produkter (panelen/steg 2 använder hela listan).
        // this.ccCards = bara de N första – det är dem hörnkortet (steg 1) bläddrar bland.
        // data-cc-max sätts från inställningen "Max antal produkter i hörnkortet".
        // MOBIL: steg 2 (panelen) finns inte – "Visa mer" går direkt till
        // kollektionssidan – så hörnkortet får bläddra bland ALLA produkter där.
        var ccMax = parseInt(this.dataset.ccMax, 10);
        if (!ccMax || ccMax < 1 || ccMax > this.cards.length || isMobile) ccMax = this.cards.length;
        this.ccCards = this.cards.slice(0, ccMax);

        // Mobil: bara EN hörnruta i taget. Är Kampanj aktiv (renderar innehåll)
        // drar sig Nyinkommet undan – Kampanj har prioritet på små skärmar.
        // (innerWidth > 0-villkoret skyddar mot 0-bredd under laddning så att
        //  Nyinkommet inte råkar tystas på desktop.)
        if (isMobile && document.querySelector('exin-kampanj .exin-kampanj-cc')) return;

        if (!this.passesFrequencyGate()) return;

        this.activeIndex = 0;
        this.buildStage();
        this.bindEvents();
        this.scheduleTrigger();
      }

      /* ---- frekvens / dismiss ---- */
      isPreview() {
        try {
          return new URLSearchParams(window.location.search).has('nyinkommet_preview');
        } catch (e) {
          return false;
        }
      }

      passesFrequencyGate() {
        if (isDesignMode || this.isPreview() || this.alwaysOn) return true;
        var u = store();
        if (u.getStorage(DISMISS_KEY)) return false;             // hård vila efter 2:a stängningen
        if ((u.getStorage(VIEWS_KEY) || 0) >= 2) return false;   // redan visad två ggr denna omgång
        // Har man stängt rutan EN gång (och inte förbrukat sin andra chans) visas
        // den igen DIREKT vid nästa sidladdning – ingen väntan på frekvensfönstret.
        // (Ifall man råkade kryssa bort den och vill se den igen.)
        if (u.getStorage(PENDING_KEY)) return true;
        if (u.getStorage(SEEN_KEY)) return false;                // annars: frekvens-mellanrum mellan de två visningarna
        return true;
      }

      markSeen() {
        if (isDesignMode || this.isPreview() || this.alwaysOn) return;
        var u = store();
        u.setStorage(SEEN_KEY, { seen: Date.now() }, this.cfg.frequencyHours / 24);
        // Räkna visningar i denna omgång. Rutan får komma tillbaka EN gång till
        // efter första stängningen (ifall man råkade kryssa bort den) – först
        // vid 2:a visningen slår vilan till. Omgången nollställs när
        // VIEWS_KEY/DISMISS_KEY hinner löpa ut (dismissDays dagar).
        var v = (u.getStorage(VIEWS_KEY) || 0) + 1;
        u.setStorage(VIEWS_KEY, v, this.cfg.dismissDays);
        u.setStorage(PENDING_KEY, 0, this.cfg.dismissDays); // andra chansen är nu förbrukad
      }

      /* ---- uppbyggnad ---- */
      buildStage() {
        var self = this;
        this.ccCards.forEach(function (card) {
          self.stage.appendChild(card);
        });
        this.setActive(0);
        this.updateCount();
      }

      setActive(i) {
        var n = this.ccCards.length;
        this.activeIndex = ((i % n) + n) % n;
        for (var k = 0; k < n; k++) {
          this.ccCards[k].classList.toggle('is-active', k === this.activeIndex);
        }
        this.buildThumbs();
      }

      buildThumbs() {
        if (!this.thumbs) return;
        this.thumbs.innerHTML = '';
        var n = this.ccCards.length;
        var label = this.querySelector('.exin-nyin-cc__peek-label');
        if (n < 2) {
          // Bara en produkt: dölj miniatyrer + "Se även", men behåll "Visa mer"
          // så panelen/nyinkommet-sidan alltid går att nå.
          if (this.peek) {
            this.peek.hidden = false;
            this.peek.classList.add('is-solo');
          }
          if (label) label.hidden = true;
          return;
        }
        if (this.peek) this.peek.classList.remove('is-solo');
        if (label) label.hidden = false;
        var self = this;
        var slots = Math.min(2, n - 1);
        for (var s = 1; s <= slots; s++) {
          var idx = (this.activeIndex + s) % n;
          var srcImg = this.ccCards[idx].querySelector('img');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'exin-nyin-cc__thumb';
          btn.setAttribute('aria-label', 'Visa nästa produkt');
          btn.dataset.target = String(idx);
          if (srcImg) {
            var im = document.createElement('img');
            im.src = srcImg.currentSrc || srcImg.src;
            im.alt = '';
            btn.appendChild(im);
          }
          btn.addEventListener('click', function () {
            self.setActive(parseInt(this.dataset.target, 10));
            self.restartRotation();
          });
          this.thumbs.appendChild(btn);
        }
      }

      updateCount() {
        var n = this.ccCards.length;
        var multi = n > 1;
        if (this.ccPrev) this.ccPrev.hidden = !multi;
        if (this.ccNext) this.ccNext.hidden = !multi;
        // "+N till"-räknaren är permanent dold – hörnkortet får ALDRIG växa på höjden
        // när det finns fler produkter än miniatyrerna visar (gäller båda blocken).
        if (this.countEl) this.countEl.hidden = true;
      }

      /* ---- events ---- */
      bindEvents() {
        var self = this;

        this.querySelectorAll('.exin-nyin-cc__close').forEach(function (b) {
          b.addEventListener('click', function () { self.dismiss(); });
        });
        if (this.moreBtn) {
          this.moreBtn.addEventListener('click', function () {
            // Mobil: hoppa över panelen – gå direkt till Nyinkommet-sidan.
            if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
              var cta = self.querySelector('.exin-nyin-panel__cta');
              var url = cta && cta.getAttribute('href');
              if (url) {
                window.location.href = url;
                return;
              }
            }
            self.openPanel();
          });
        }
        this.querySelectorAll('[data-close]').forEach(function (b) {
          b.addEventListener('click', function () { self.closePanel(); });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.panelOpen) self.closePanel();
        });
        if (this.ccPrev) {
          this.ccPrev.addEventListener('click', function () { self.setActive(self.activeIndex - 1); });
        }
        if (this.ccNext) {
          this.ccNext.addEventListener('click', function () { self.setActive(self.activeIndex + 1); });
        }
        if (this.panelPrev) {
          this.panelPrev.addEventListener('click', function () { self.scrollPanel(-1); });
        }
        if (this.panelNext) {
          this.panelNext.addEventListener('click', function () { self.scrollPanel(1); });
        }
      }

      /* ---- trigger ---- */
      scheduleTrigger() {
        var self = this;

        // Byggläge: visa nästan direkt så resultatet är lätt att se.
        if (this.alwaysOn) {
          setTimeout(function () { self.show(); }, 400);
          return;
        }

        var fired = false;
        var go = function () {
          if (fired) return;
          fired = true;
          window.removeEventListener('scroll', onScroll);
          self.show();
        };
        var onScroll = function () {
          var y = window.pageYOffset || document.documentElement.scrollTop || 0;
          if (y > self.cfg.scrollPx) go();
        };

        if (this.cfg.trigger === 'delay' || this.cfg.trigger === 'both') {
          setTimeout(go, this.cfg.delayMs);
        }
        if (this.cfg.trigger === 'scroll' || this.cfg.trigger === 'both') {
          window.addEventListener('scroll', onScroll, { passive: true });
        }
      }

      // Krockar inte med cookie-samtyckesrutan: om Shopifys samtyckesruta syns
      // väntar vi tills besökaren gjort sitt val (eller max 25s) innan kortet visas.
      _consentBlocking() {
        var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
        return !!(b && b.offsetParent !== null);
      }

      show() {
        if (this.shown) return;
        var self = this;
        if (!this._consentWaitStarted && this._consentBlocking()) {
          this._consentWaitStarted = Date.now();
          this._consentIv = setInterval(function () {
            if (!self._consentBlocking() || Date.now() - self._consentWaitStarted > 25000) {
              clearInterval(self._consentIv);
              self._consentIv = null;
              self._reveal();
            }
          }, 400);
          return;
        }
        if (this._consentIv) { clearInterval(this._consentIv); this._consentIv = null; }
        this._reveal();
      }

      _reveal() {
        if (this.shown) return;
        this.shown = true;
        this.cc.hidden = false;
        // Framtvinga reflow så entré-övergången animerar från dolt läge – utan
        // beroende på requestAnimationFrame (som pausas i bakgrundsflikar).
        void this.cc.offsetWidth;
        this.classList.add('is-visible');
        this.markSeen();
        this.dispatchEvent(new CustomEvent('exin:nyinkommet:shown', { bubbles: true }));
      }

      /* ---- navigering ----
         Ingen auto-rotation längre – användaren byter produkt med pilarna.
         Stubbar kvar så äldre anrop (miniatyrklick, openPanel, dismiss) inte kraschar. */
      startRotation() {}
      pauseRotation() {}
      resumeRotation() {}
      restartRotation() {}

      scrollPanel(dir) {
        if (!this.panelGrid) return;
        var card = this.panelGrid.querySelector('.exin-nyin-card');
        var step = card ? Math.round(card.getBoundingClientRect().width) + 20 : 260;
        var max = this.panelGrid.scrollWidth - this.panelGrid.clientWidth;
        var target = Math.max(0, Math.min(max, this.panelGrid.scrollLeft + dir * step));
        // Mjuk scroll via CSS scroll-behavior; direkt tilldelning så positionen
        // alltid landar även om animationen är strypt.
        this.panelGrid.scrollLeft = target;
      }

      /* ---- panelbredd = temats innehållsbredd (mät en riktig .page-width) ---- */
      findPageWidthRef() {
        var scope =
          document.querySelector('#MainContent') ||
          document.querySelector('main') ||
          document.body;
        var els = scope.querySelectorAll('.page-width');
        for (var i = 0; i < els.length; i++) {
          var e = els[i];
          var cn = e.className || '';
          if (cn.indexOf('--full') > -1 || cn.indexOf('--narrow') > -1) continue;
          var cs = window.getComputedStyle(e);
          if (parseFloat(cs.paddingLeft) < 1) continue;
          var r = e.getBoundingClientRect();
          if (r.width > 400 && r.width <= window.innerWidth + 4) return e;
        }
        return null;
      }

      sizePanel() {
        if (!this.panel) return;
        var left, width;
        var ref = this.findPageWidthRef();
        if (ref) {
          var r = ref.getBoundingClientRect();
          var cs = window.getComputedStyle(ref);
          left = r.left + parseFloat(cs.paddingLeft);
          width = r.width - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        } else {
          // Fallback: klientbredd (utan scrollbar) minus temats --page-padding.
          var probe = document.createElement('div');
          probe.style.cssText =
            'position:absolute;visibility:hidden;height:0;width:var(--page-padding,1.6rem)';
          document.body.appendChild(probe);
          var pad = parseFloat(window.getComputedStyle(probe).width) || 24;
          probe.remove();
          left = pad;
          width = document.documentElement.clientWidth - pad * 2;
        }
        this.panel.style.setProperty('--enyin-panel-left', Math.round(left) + 'px');
        this.panel.style.setProperty('--enyin-panel-w', Math.round(width) + 'px');
      }

      /* ---- panel: "tidnings-utrullning" ----
         Samma teknik som Workspace Studios showStep(): ren CSS-transition på
         .exin-nyin-panel__box + en .is-rolling-klass som läggs på, tvingar en
         reflow (void offsetWidth), och tas bort igen – så webbläsaren har ett
         "från"-läge (hoprullat i nedre högra hörnet) att animera FRÅN. Fungerar
         även när panelen går från display:none till synlig, till skillnad från
         en ren transition eller Web Animations API på ett nyss visat element. */
      openPanel() {
        if (this.panelOpen || !this.panel) return;
        this.panelOpen = true;
        this.pauseRotation();
        if (!this._onResize) {
          var selfR = this;
          this._onResize = function () {
            if (selfR.panelOpen) selfR.sizePanel();
          };
          window.addEventListener('resize', this._onResize);
        }

        var self = this;

        // Bygg panelens kort som KLONER – originalen lämnas orörda i hörnkortet,
        // så steg 1 inte behöver renderas om (och produktbilden inte laddas om)
        // när panelen stängs. Görs bara EN gång per sida (cachas) i stället för
        // vid varje öppning – att riva ned och återskapa alla kort (inkl.
        // bilder som då avkodas om) precis när utrullnings-animationen skulle
        // starta gav en ojämn/hackig rörelse, särskilt andra/tredje gången
        // panelen öppnades innan webbläsarens bild-cache hunnit "värmas upp".
        if (!this._panelGridBuilt) {
          this.panelGrid.innerHTML = '';
          this.cards.forEach(function (card) {
            var clone = card.cloneNode(true);
            clone.classList.remove('is-active');
            self.panelGrid.appendChild(clone);
          });
          this._panelGridBuilt = true;
        }
        var n = this.cards.length;
        var many = n > 4;
        this.panelGrid.dataset.count = many ? 'many' : String(n);
        // 4+ produkter = bläddringsbar rad → visa pilarna
        var scrollRow = n >= 4;
        if (this.panelPrev) this.panelPrev.hidden = !scrollRow;
        if (this.panelNext) this.panelNext.hidden = !scrollRow;

        this._scrollY = window.pageYOffset;
        // Lås sidscroll och kompensera för scrollbaren med padding, så sidan varken
        // hoppar i sidled eller blinkar fram en scrollbar. Mät panelbredden EFTER det.
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.overflow = 'hidden';
        if (sbw > 0) document.documentElement.style.paddingRight = sbw + 'px';
        this.sizePanel();

        this.panel.hidden = false;
        this.classList.add('panel-active');
        this.panel.classList.add('is-open');
        // "från"-läge (hoprullat) + tvingad reflow så starttillståndet committas ...
        this.panel.classList.add('is-rolling');
        void this.panelBox.offsetWidth;
        // ... ta sedan bort det, via DUBBEL rAF i stället för bara den synkrona
        // reflowen ovan → garanterar att webbläsaren hunnit MÅLA det hoprullade
        // läget innan vi startar CSS-transitionen ut till platt läge. Utan detta
        // kunde en snabb stäng+öppna-cykel (panelen stängs medan förra
        // utrullningen fortfarande pågår) ibland resultera i att nästa
        // utrullning aldrig riktigt startade om – rutan fastnade hoprullad/
        // halvvägs trots att is-rolling redan tagits bort.
        // Avbryt först en ev. VÄNTANDE rAF-kedja från en tidigare öppning som
        // inte hann slutföras – annars kan flera kedjor ligga och köa samtidigt
        // och ta bort is-rolling vid fel tillfälle på en senare cykel, vilket
        // gör att utrullningen hackar/rycker till vid upprepade öppna/stäng.
        if (this._openRaf1) cancelAnimationFrame(this._openRaf1);
        if (this._openRaf2) cancelAnimationFrame(this._openRaf2);
        this._openRaf1 = requestAnimationFrame(function () {
          self._openRaf2 = requestAnimationFrame(function () {
            self.panel.classList.remove('is-rolling');
            self._openRaf1 = null;
            self._openRaf2 = null;
          });
        });

        this._trap = this.trapFocus.bind(this);
        document.addEventListener('keydown', this._trap, true);
        var firstFocusable = this.panelBox.querySelector('button, a[href]');
        if (firstFocusable) firstFocusable.focus({ preventScroll: true });
        this.dispatchEvent(new CustomEvent('exin:nyinkommet:panel-open', { bubbles: true }));
      }

      closePanel() {
        if (!this.panelOpen) return;
        this.panelOpen = false;
        // Avbryt en ev. väntande utrullnings-rAF-kedja (se openPanel) så den
        // inte kan fira senare och krocka med en ny öppning.
        if (this._openRaf1) { cancelAnimationFrame(this._openRaf1); this._openRaf1 = null; }
        if (this._openRaf2) { cancelAnimationFrame(this._openRaf2); this._openRaf2 = null; }

        // Omedelbar stängning – ingen hoprullnings-animation. Hörnkortet är orört
        // (panelkorten var kloner) så steg 1 kommer tillbaka utan omrendering.
        this.panel.classList.remove('is-open');
        this.panel.classList.remove('is-rolling');
        this.panel.hidden = true;
        // OBS: panelGrid rivs INTE längre ned här – korten cachas (se
        // openPanel/_panelGridBuilt) och återanvänds nästa öppning.
        this.classList.remove('panel-active');
        document.documentElement.style.overflow = '';
        document.documentElement.style.paddingRight = '';
        if (this._trap) document.removeEventListener('keydown', this._trap, true);

        if (this.moreBtn) this.moreBtn.focus();
        if (!reduceMotion) this.resumeRotation();
      }

      trapFocus(e) {
        if (e.key !== 'Tab') return;
        var f = this.panelBox.querySelectorAll(
          'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
        );
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      /* ---- dismiss ---- */
      dismiss() {
        this.classList.remove('is-visible');
        this.pauseRotation();
        var self = this;
        var done = function () {
          self.cc.hidden = true;
          self.removeEventListener('transitionend', done);
        };
        if (reduceMotion) done();
        else this.addEventListener('transitionend', done);

        if (!isDesignMode && !this.isPreview() && !this.alwaysOn) {
          var u = store();
          // Första stängningen räknas INTE som ett definitivt nej – SEEN_KEY gör
          // bara att rutan pausar i frequencyHours och kommer tillbaka en andra
          // gång. Först när den redan visats 2 ggr läggs den i vila i
          // dismissDays dagar (och omgången nollställs).
          if ((u.getStorage(VIEWS_KEY) || 0) >= 2) {
            u.setStorage(DISMISS_KEY, { dismissed: Date.now() }, this.cfg.dismissDays);
            u.setStorage(VIEWS_KEY, 0, this.cfg.dismissDays);
            u.setStorage(PENDING_KEY, 0, this.cfg.dismissDays);
          } else {
            // Första stängningen: arma en "andra chans" så rutan kommer tillbaka
            // direkt vid nästa sidladdning (ifall man råkade kryssa bort den).
            u.setStorage(PENDING_KEY, 1, this.cfg.dismissDays);
          }
        }
        this.dispatchEvent(new CustomEvent('exin:nyinkommet:dismissed', { bubbles: true }));
      }
    }
  );
})();
